// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.tournament-form-edit-inscription__title.baloa-subtitle-2{
    color: var(--primary-very-dark-color);
    padding-bottom: var(--space-and-half);
}

.tournament-form-edit-inscription__content .baloa-username {
    color: var(--primary-very-dark-color);
    padding-bottom: var(--space-half);
}

.tournament-form-edit-inscription__content .MuiFormGroup-root{
    flex-wrap: nowrap;
}

.MuiFormGroup-root.tournament-form-edit-inscription__content__option-button{
    padding-bottom: var(--space-and-half);
}
.tournament-form-edit-inscription__content__option-button .MuiRadio-root{
    color: var(--new-gray-background-color);
}
.tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-root{
    border-radius: 13px;
    border: 1px solid var(--new-gray-background-color);
    margin-left: 0;
    min-width: 122px;
}
.tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-root.selected{
    border: 1px solid var(--new-green-color);
    margin-left: 0;
    min-width: 145px;
}

.tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementStart{
    margin: 0;
    padding: var(--space-half-quarter) var(--space);
    margin-right: var(--space);
    justify-content: space-between;
}
.tournament-form-edit-inscription__content__half-buttons{
    width: 100%;
}
.tournament-form-edit-inscription__content__half-buttons .tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-root{
    margin: 0;
    width: 50%;
    margin-right: var(--space);
}
.tournament-form-edit-inscription__content__half-buttons span.baloa-username {
    color: var(--primary-very-dark-color);
    padding: var(--space) 0;
}

.tournament-form-edit-inscription__content__half-buttons.hidden {
    display: none;
}
.tournament-form-edit-inscription__content__option-button-label{
    display: flex;
    align-items: center;
    
}
.tournament-form-edit-inscription__content__option-button-label .icon-email ,
.tournament-form-edit-inscription__content__option-button-label .icon-group-friends,
.tournament-form-edit-inscription__content__option-button-label .icon-team{
    font-size: 34px;
    color: var(--new-green-color);
    padding-right: var(--space-and-half);
}
.tournament-form-edit-inscription__content__option-button-label__text{

}

.tournament-form-edit-inscription__content__option-button-label__text-title{

}

.tournament-form-edit-inscription__content__option-button-label__caption{

}

.tournament-form-edit-inscription__content .input-field {
    padding-right: var(--space);
    padding-bottom: var(--space);
    width: 50%;
    margin: 0;
}
.tournament-form-edit-inscription__content .input-field-multiline {
    padding-right: var(--space);
    padding-bottom: var(--space);
    margin: 0;
}
.tournament-form-edit-inscription__content .input-field-input{
    background: #FFFFFF;
    border: 1px solid var(--new-gray-background-color);
}

.tournament-form-edit-inscription__content .input-field-multiline-input{
    background: #FFFFFF;
    border: 1px solid var(--new-gray-background-color);
}

.tournament-form-edit-inscription__content__double-input{
    display: flex;
    align-items: center;
    margin-bottom: var(--space);
}

.tournament-form-edit-inscription__content__double-input .disabledMax .input-field-input {
    background-color: var(--new-gray-background-color);
    color: var(--new-gray-background-color);
}

.tournament-form-edit-inscription__content__group-input{
    width: 50%;
}

.tournament-form-edit-inscription__content__group-input .input-field{
    width: 100%;
}

.one-column{
    width: 50%;
    align-items: center;
    padding-bottom: var(--space);
}

.one-column .input-field {
    width: 30%;
    padding: 0;
}
.MuiFormGroup-root.tournament-form-edit-inscription__content__option-button.inside {
    padding-bottom: 0;
    min-height: 48px;
}

.tournament-form-edit-inscription__content__one-button{
    width: 33%;
}
.tournament-form-edit-inscription__content__one-button .tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-root{
    margin: 0;
    width: 100%;
    margin-left: var(--space);
}
.tournament-form-edit-inscription__content__one-button span.baloa-username {
    color: var(--primary-very-dark-color);
    padding: var(--space) 0;
}

.tournament-form-edit-inscription__content__tree-button{

}

.tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-label.Mui-disabled .baloa-username, 
.tournament-form-edit-inscription__content__option-button .MuiRadio-colorSecondary.Mui-disabled {
    color: var(--disabled-color);
}

.tournament-inscription_radio_dinamic_Form .baloa-table{
    color: var(--new-green-color);
    font-weight:var(--font-medium);
    padding-bottom: var(--space-half);
}

.tournament-inscription_radio_dinamic_Form .baloa-table:hover{
    cursor: pointer;
}

.tooltip {
    position: relative;
    display: inline-block;
}

.tooltip .tooltiptext {
    display:flex;
    flex-direction: column;
    align-items: flex-start;
    visibility: hidden;
    width: 20rem;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    border-radius: 6px;
    padding: 10px;
    position: absolute;
    left: 24px;
    top: -17px;
    z-index: 1;
}

.tooltiptext .baloa-username{
    color: var(--primary-dark-color);
}

.tooltiptext .baloa-table{
    color: var(--primary-dark-color);
    margin-bottom: var(--space-half);
    margin-left: var(--space-quarter);
}

.tooltiptext_grid_title{
    display: flex;
    align-items: baseline;
}

.tooltip:hover{
    cursor: pointer;
}

.tooltip:hover .tooltiptext {
    visibility: visible;
}

.tournament-form-edit-inscription__content_tooltip{
    display: flex;
    align-items: baseline;
}

.tournament-form-edit-inscription__content_tooltip_center_input{
    display: flex;
    align-items: center;
}

.basic-data__form_edit_content_number_teams_input_grid-tooltip{
    margin-left: var(--space-and-half);
}

.tournament-form-edit-inscription__content .tournament-form-edit-inscription__content__double-input.one-column 
.basic-data__form_edit_content__input.disabled .input-field-input {
    color: var(--disabled-color);
}

.tournament-form-edit-inscription__content .tournament-form-edit-inscription__content_tooltip
.basic-data__form_edit_content__input.disabled .input-field-input {
    color: var(--disabled-color);
}

.tournament-inscription__form-control:active,.tournament-inscription__form-control:focus {
    border: 1px solid var(--new-gray-background-color);
    outline: none;
}

.tournament-form-edit-inscription__content__group-input .input-field {
    width: 100%;
}

input.tournament-inscription__form-control.disabled{
    color: var(--disabled-color);
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-inscription-form-edit/TournamentInscriptionFormEditComponent.styles.css"],"names":[],"mappings":";AACA;IACI,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;AACzC;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,mBAAmB;IACnB,kDAAkD;IAClD,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,wCAAwC;IACxC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,+CAA+C;IAC/C,0BAA0B;IAC1B,8BAA8B;AAClC;AACA;IACI,WAAW;AACf;AACA;IACI,SAAS;IACT,UAAU;IACV,0BAA0B;AAC9B;AACA;IACI,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;;AAEvB;AACA;;;IAGI,eAAe;IACf,6BAA6B;IAC7B,oCAAoC;AACxC;AACA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,UAAU;IACV,SAAS;AACb;AACA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,kDAAkD;IAClD,uCAAuC;AAC3C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,UAAU;AACd;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;AACA;IACI,SAAS;IACT,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,qCAAqC;IACrC,uBAAuB;AAC3B;;AAEA;;AAEA;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,UAAU;AACd;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,kDAAkD;IAClD,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":["\n.tournament-form-edit-inscription__title.baloa-subtitle-2{\n    color: var(--primary-very-dark-color);\n    padding-bottom: var(--space-and-half);\n}\n\n.tournament-form-edit-inscription__content .baloa-username {\n    color: var(--primary-very-dark-color);\n    padding-bottom: var(--space-half);\n}\n\n.tournament-form-edit-inscription__content .MuiFormGroup-root{\n    flex-wrap: nowrap;\n}\n\n.MuiFormGroup-root.tournament-form-edit-inscription__content__option-button{\n    padding-bottom: var(--space-and-half);\n}\n.tournament-form-edit-inscription__content__option-button .MuiRadio-root{\n    color: var(--new-gray-background-color);\n}\n.tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-root{\n    border-radius: 13px;\n    border: 1px solid var(--new-gray-background-color);\n    margin-left: 0;\n    min-width: 122px;\n}\n.tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-root.selected{\n    border: 1px solid var(--new-green-color);\n    margin-left: 0;\n    min-width: 145px;\n}\n\n.tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-root.MuiFormControlLabel-labelPlacementStart{\n    margin: 0;\n    padding: var(--space-half-quarter) var(--space);\n    margin-right: var(--space);\n    justify-content: space-between;\n}\n.tournament-form-edit-inscription__content__half-buttons{\n    width: 100%;\n}\n.tournament-form-edit-inscription__content__half-buttons .tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-root{\n    margin: 0;\n    width: 50%;\n    margin-right: var(--space);\n}\n.tournament-form-edit-inscription__content__half-buttons span.baloa-username {\n    color: var(--primary-very-dark-color);\n    padding: var(--space) 0;\n}\n\n.tournament-form-edit-inscription__content__half-buttons.hidden {\n    display: none;\n}\n.tournament-form-edit-inscription__content__option-button-label{\n    display: flex;\n    align-items: center;\n    \n}\n.tournament-form-edit-inscription__content__option-button-label .icon-email ,\n.tournament-form-edit-inscription__content__option-button-label .icon-group-friends,\n.tournament-form-edit-inscription__content__option-button-label .icon-team{\n    font-size: 34px;\n    color: var(--new-green-color);\n    padding-right: var(--space-and-half);\n}\n.tournament-form-edit-inscription__content__option-button-label__text{\n\n}\n\n.tournament-form-edit-inscription__content__option-button-label__text-title{\n\n}\n\n.tournament-form-edit-inscription__content__option-button-label__caption{\n\n}\n\n.tournament-form-edit-inscription__content .input-field {\n    padding-right: var(--space);\n    padding-bottom: var(--space);\n    width: 50%;\n    margin: 0;\n}\n.tournament-form-edit-inscription__content .input-field-multiline {\n    padding-right: var(--space);\n    padding-bottom: var(--space);\n    margin: 0;\n}\n.tournament-form-edit-inscription__content .input-field-input{\n    background: #FFFFFF;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-form-edit-inscription__content .input-field-multiline-input{\n    background: #FFFFFF;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.tournament-form-edit-inscription__content__double-input{\n    display: flex;\n    align-items: center;\n    margin-bottom: var(--space);\n}\n\n.tournament-form-edit-inscription__content__double-input .disabledMax .input-field-input {\n    background-color: var(--new-gray-background-color);\n    color: var(--new-gray-background-color);\n}\n\n.tournament-form-edit-inscription__content__group-input{\n    width: 50%;\n}\n\n.tournament-form-edit-inscription__content__group-input .input-field{\n    width: 100%;\n}\n\n.one-column{\n    width: 50%;\n    align-items: center;\n    padding-bottom: var(--space);\n}\n\n.one-column .input-field {\n    width: 30%;\n    padding: 0;\n}\n.MuiFormGroup-root.tournament-form-edit-inscription__content__option-button.inside {\n    padding-bottom: 0;\n    min-height: 48px;\n}\n\n.tournament-form-edit-inscription__content__one-button{\n    width: 33%;\n}\n.tournament-form-edit-inscription__content__one-button .tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-root{\n    margin: 0;\n    width: 100%;\n    margin-left: var(--space);\n}\n.tournament-form-edit-inscription__content__one-button span.baloa-username {\n    color: var(--primary-very-dark-color);\n    padding: var(--space) 0;\n}\n\n.tournament-form-edit-inscription__content__tree-button{\n\n}\n\n.tournament-form-edit-inscription__content__option-button .MuiFormControlLabel-label.Mui-disabled .baloa-username, \n.tournament-form-edit-inscription__content__option-button .MuiRadio-colorSecondary.Mui-disabled {\n    color: var(--disabled-color);\n}\n\n.tournament-inscription_radio_dinamic_Form .baloa-table{\n    color: var(--new-green-color);\n    font-weight:var(--font-medium);\n    padding-bottom: var(--space-half);\n}\n\n.tournament-inscription_radio_dinamic_Form .baloa-table:hover{\n    cursor: pointer;\n}\n\n.tooltip {\n    position: relative;\n    display: inline-block;\n}\n\n.tooltip .tooltiptext {\n    display:flex;\n    flex-direction: column;\n    align-items: flex-start;\n    visibility: hidden;\n    width: 20rem;\n    background: #FFFFFF;\n    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 8px;\n    border-radius: 6px;\n    padding: 10px;\n    position: absolute;\n    left: 24px;\n    top: -17px;\n    z-index: 1;\n}\n\n.tooltiptext .baloa-username{\n    color: var(--primary-dark-color);\n}\n\n.tooltiptext .baloa-table{\n    color: var(--primary-dark-color);\n    margin-bottom: var(--space-half);\n    margin-left: var(--space-quarter);\n}\n\n.tooltiptext_grid_title{\n    display: flex;\n    align-items: baseline;\n}\n\n.tooltip:hover{\n    cursor: pointer;\n}\n\n.tooltip:hover .tooltiptext {\n    visibility: visible;\n}\n\n.tournament-form-edit-inscription__content_tooltip{\n    display: flex;\n    align-items: baseline;\n}\n\n.tournament-form-edit-inscription__content_tooltip_center_input{\n    display: flex;\n    align-items: center;\n}\n\n.basic-data__form_edit_content_number_teams_input_grid-tooltip{\n    margin-left: var(--space-and-half);\n}\n\n.tournament-form-edit-inscription__content .tournament-form-edit-inscription__content__double-input.one-column \n.basic-data__form_edit_content__input.disabled .input-field-input {\n    color: var(--disabled-color);\n}\n\n.tournament-form-edit-inscription__content .tournament-form-edit-inscription__content_tooltip\n.basic-data__form_edit_content__input.disabled .input-field-input {\n    color: var(--disabled-color);\n}\n\n.tournament-inscription__form-control:active,.tournament-inscription__form-control:focus {\n    border: 1px solid var(--new-gray-background-color);\n    outline: none;\n}\n\n.tournament-form-edit-inscription__content__group-input .input-field {\n    width: 100%;\n}\n\ninput.tournament-inscription__form-control.disabled{\n    color: var(--disabled-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
